import { render, staticRenderFns } from "./ed-subject-builder-rules.component.vue?vue&type=template&id=385409a9&scoped=true&"
import script from "./ed-subject-builder-rules.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-rules.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-rules.component.scss?vue&type=style&index=0&id=385409a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385409a9",
  null
  
)

export default component.exports